
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ReceptionDetailSummary } from "../../../domain/workflow/list";

@Component({
})
export default class WorkflowListViewStyleMixin extends Mixins() {
  @Prop()
  source: ReceptionDetailSummary[];

  @Prop()
  generalFlagLabelName: string;

  @Prop()
  isFinishTabEnable: boolean;

  @Prop()
  searchLimitOverMessage: string;

  @Prop()
  chunkSize: number;

  @Prop({ default: false })
  isReadOnly: boolean;

  @Prop()
  highlightedManagerId: string;

  @Emit()
  deletedReceptionDetail(): void {}

  @Emit()
  doActionReceptionDetail(): void {}

  @Emit()
  ready(): void {}

  onDeletedReceptionDetailNotify(): void {
    this.deletedReceptionDetail();
  }

  onDoActionedReceptionDetailNotify(): void {
    this.doActionReceptionDetail();
  }
}
